import React from 'react';
import { Avatar } from 'flowbite-react';
import { Img } from 'react-image';
import { SwiperComponent } from '../shared/SwiperComponent';

interface Props {
	data: { name: string; imgUrl: string; companyName: string; linkedinUrl: string; description: string }[];
	customCss?: string;
}

const JapTestimonial = ({ data, customCss = 'sm:h-[262px]' }: Props) => {
	return (
		<div className={`mx-auto mt-6 overflow-hidden relative`}>
			<SwiperComponent
				options={{
					spaceBetween: 10,
					slidesPerView: 1,
					mousewheel: {
						sensitivity: 1,
						forceToAxis: true,
					},
					autoplay: {
						delay: 5000,
						disableOnInteraction: false,
					},
				}}
			>
				{data.map((item, i) => {
					return (
						<div
							key={i}
							className="bg-white dark:bg-[#243443] h-full border dark:border-[rgba(255,_255,_255,_0.04)] px-3 flex flex-col gap-4 py-4 rounded-[8px]"
						>
							<div className="flex gap-3">
								<div>
									<Avatar rounded img={item.imgUrl} />
								</div>
								<div className="font-inter">
									<p className="flex gap-1 items-center">
										{item.name}{' '}
										{item.linkedinUrl ? (
											<Img
												onClick={() => {
													window.open(item.linkedinUrl, '_blank');
												}}
												className="cursor-pointer"
												loading="lazy"
												src="/assets/linkedinIcon.svg"
												width="12"
												height="12"
												alt="linkedin"
											/>
										) : null}
									</p>
									<p className="text-[#7E868C] text-[12px]">{item.companyName}</p>
								</div>
							</div>
							<div className="text-gray-700 dark:text-[#C7CBCE] text-[14px] italic font-[500]">{item.description}</div>
						</div>
					);
				})}
			</SwiperComponent>
		</div>
	);
};

export default JapTestimonial;
